const TourJobTypeLabel = ["Immersive 3D Tour Panoramas", "Immersive 3D Tour Panorama with Floor plan"];

export default TourJobTypeLabel;
